import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import {
    PropertyDefinition, PropertyMappingType,
} from "app/library/layout-builder";
import { VenueRentalAccordionProps } from "./types";
import { ImageChildrenDefinitions } from 'components/cms/definitions';

export class VenueRentalAccordionDefinitions extends CmsReactComponent<VenueRentalAccordionProps> {
    static defaultProps = {};

    static schemaName = "venue-rental-accordion";

    static propertyDefinitions: PropertyDefinition[] = [
        {
            name: 'accordions',
            text: 'Veriler',
            mapping: {
                type: PropertyMappingType.ArrayData,
                keys: [{
                    name: "key",
                    text: "Anahtar (ÖR: cok-amacli-salon)",
                    mapping: {
                        type: PropertyMappingType.String,
                    }
                },
                {
                    name: "title",
                    text: "Başlık",
                    mapping: {
                        type: PropertyMappingType.String,
                    }
                },
                {
                    name: "listImage",
                    text: "Liste Görseli",
                    mapping: {
                        type: PropertyMappingType.Image,
                        children: ImageChildrenDefinitions
                    }
                },
                {
                    name: "image",
                    text: "Görsel",
                    mapping: {
                        type: PropertyMappingType.Image,
                        children: ImageChildrenDefinitions
                    }
                },
                {
                    name: "content",
                    text: "İçerik",
                    mapping: {
                        type: PropertyMappingType.Html,
                    }
                },
                {
                    name: "listContent",
                    text: "Liste İçeriği",
                    mapping: {
                        type: PropertyMappingType.Html,
                    }
                },
                {
                    name: "tableContent",
                    text: "Tablo İçeriği",
                    mapping: {
                        type: PropertyMappingType.Html,
                    }
                },
                {
                    name: "tablePosition",
                    text: "Tablo Pozisyonu",
                    description: "Tablonun Gözükeceği Pozisyonu Seçiniz",
                    mapping: {
                        type: PropertyMappingType.Object,
                        oneOf: [
                            {
                                key: "left",
                                text: "Sol",
                            },
                            {
                                key: "right",
                                text: "Sağ",
                            }
                        ],
                    },
                },
                {
                    name: 'files',
                    text: 'Dosyalar',
                    mapping: {
                        type: PropertyMappingType.ArrayData,
                        keys: [{
                            name: "title",
                            text: "Başlık",
                            mapping: {
                                type: PropertyMappingType.String,
                            }
                        },
                        {
                            name: "file",
                            text: "Dosya",
                            mapping: {
                                type: PropertyMappingType.File,
                            }
                        },
                        ]
                    }
                }]
            }
        }
    ];
}
